define.alias("shared/helpers/word-initials", "media/helpers/word-initials");